document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute("role", "button");
  summary.setAttribute(
    "aria-expanded",
    summary.parentNode.hasAttribute("open")
  );

  if (summary.nextElementSibling.getAttribute("id")) {
    summary.setAttribute("aria-controls", summary.nextElementSibling.id);
  }

  summary.addEventListener("click", (event) => {
    event.currentTarget.setAttribute(
      "aria-expanded",
      !event.currentTarget.closest("details").hasAttribute("open")
    );
  });

  if (summary.closest("header-drawer")) return;
  summary.parentElement.addEventListener("keyup", onKeyUpEscape);
});

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    "ARROWUP",
    "ARROWDOWN",
    "ARROWLEFT",
    "ARROWRIGHT",
    "TAB",
    "ENTER",
    "SPACE",
    "ESCAPE",
    "HOME",
    "END",
    "PAGEUP",
    "PAGEDOWN",
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener("keydown", (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener("mousedown", (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    "focus",
    () => {
      if (currentFocusedElement)
        currentFocusedElement.classList.remove("focused");

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add("focused");
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll(".js-youtube").forEach((video) => {
    video.contentWindow.postMessage(
      '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
      "*"
    );
  });
  document.querySelectorAll(".js-vimeo").forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', "*");
  });
  document.querySelectorAll("video").forEach((video) => video.pause());
  document.querySelectorAll("product-model").forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== "ESCAPE") return;

  const openDetailsElement = event.target.closest("details[open]");
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector("summary");
  openDetailsElement.removeAttribute("open");
  summaryElement.setAttribute("aria-expanded", false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");
    this.changeEvent = new Event("change", { bubbles: true });

    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    const step = this.input.dataset.step ?? 1;

    event.target.name === "plus" ? this.input.stepUp(step) : this.input.stepDown(step);
    if (previousValue !== this.input.value)
      this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define("quantity-input", QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options["method"] || "post";
  var params = options["parameters"] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options["hideElement"] || province_domid
  );

  Shopify.addListener(
    this.countryEl,
    "change",
    Shopify.bind(this.countryHandler, this)
  );

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute("data-provinces");
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector("details");

    this.addEventListener("keyup", this.onKeyUp.bind(this));
    this.addEventListener("focusout", this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll("summary").forEach((summary) =>
      summary.addEventListener("click", this.onSummaryClick.bind(this))
    );
    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onCloseButtonClick.bind(this))
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== "ESCAPE") return;

    const openDetailsElement = event.target.closest("details[open]");
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(
          event,
          this.mainDetailsToggle.querySelector("summary")
        )
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest(".has-submenu");
    const isOpen = detailsElement.hasAttribute("open");
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(
        summaryElement.nextElementSibling,
        detailsElement.querySelector("button")
      );
      summaryElement.nextElementSibling.removeEventListener(
        "transitionend",
        addTrapFocus
      );
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen
        ? this.closeMenuDrawer(event, summaryElement)
        : this.openMenuDrawer(summaryElement);

      if (window.matchMedia("(max-width: 990px)")) {
        document.documentElement.style.setProperty(
          "--viewport-height",
          `${window.innerHeight}px`
        );
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add("menu-opening");
        summaryElement.setAttribute("aria-expanded", true);
        parentMenuElement && parentMenuElement.classList.add("submenu-open");
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener(
              "transitionend",
              addTrapFocus
            );
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });
    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove("menu-opening");
    this.mainDetailsToggle.querySelectorAll("details").forEach((details) => {
      details.removeAttribute("open");
      details.classList.remove("menu-opening");
    });
    this.mainDetailsToggle
      .querySelectorAll(".submenu-open")
      .forEach((submenu) => {
        submenu.classList.remove("submenu-open");
      });
    document.body.classList.remove(
      `overflow-hidden-${this.dataset.breakpoint}`
    );
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (
        this.mainDetailsToggle.hasAttribute("open") &&
        !this.mainDetailsToggle.contains(document.activeElement)
      )
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest("details");
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest(".submenu-open");
    parentMenuElement && parentMenuElement.classList.remove("submenu-open");
    detailsElement.classList.remove("menu-opening");
    detailsElement
      .querySelector("summary")
      .setAttribute("aria-expanded", false);
    removeTrapFocus(detailsElement.querySelector("summary"));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute("open");
        if (detailsElement.closest("details[open]")) {
          trapFocus(
            detailsElement.closest("details[open]"),
            detailsElement.querySelector("summary")
          );
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define("menu-drawer", MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header =
      this.header || document.getElementById("shopify-section-header");
    this.borderOffset =
      this.borderOffset ||
      this.closest(".header-wrapper").classList.contains(
        "header-wrapper--border-bottom"
      )
        ? 1
        : 0;
    document.documentElement.style.setProperty(
      "--header-bottom-position",
      `${parseInt(
        this.header.getBoundingClientRect().bottom - this.borderOffset
      )}px`
    );
    this.header.classList.add("menu-open");

    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });

    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove("menu-open");
  }
}

customElements.define("header-drawer", HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      "click",
      this.hide.bind(this, false)
    );
    this.addEventListener("keyup", (event) => {
      if (event.code.toUpperCase() === "ESCAPE") this.hide();
    });
    if (this.classList.contains("media-modal")) {
      this.addEventListener("pointerup", (event) => {
        if (
          event.pointerType === "mouse" &&
          !event.target.closest("deferred-media, product-model")
        )
          this.hide();
      });
    } else {
      this.addEventListener("click", (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector(".template-popup");
    document.body.classList.add("overflow-hidden");
    this.setAttribute("open", "");
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove("overflow-hidden");
    document.body.dispatchEvent(new CustomEvent("modalClosed"));
    this.removeAttribute("open");
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define("modal-dialog", ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector(".product-popup-modal__button");

    if (!button) return;
    button.addEventListener("click", (e) => {
      e.preventDefault();
      const modal = document.querySelector(this.getAttribute("data-modal"));
      if (modal) modal.show(button);
    });
  }
}
customElements.define("modal-opener", ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener("click", this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute("loaded")) {
      const content = document.createElement("div");
      content.appendChild(
        this.querySelector("template").content.firstElementChild.cloneNode(true)
      );

      this.setAttribute("loaded", true);
      const deferredElement = this.appendChild(
        content.querySelector("video, model-viewer, iframe")
      );
      if (focus) deferredElement.focus();
    }
  }
}

customElements.define("deferred-media", DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector(".slider-counter--current");
    this.pageTotalElement = this.querySelector(".slider-counter--total");
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener("scroll", this.update.bind(this));
    this.prevButton.addEventListener("click", this.onButtonClick.bind(this));
    this.nextButton.addEventListener("click", this.onButtonClick.bind(this));
  }

  initPages() {
    if (this.slider.classList.contains("slider--vertical")) {
      this.sliderItemsToShow = Array.from(this.sliderItems).filter(
        (element) => element.clientHeight > 0
      );
      if (this.sliderItemsToShow.length < 2) return;
      this.sliderItemOffset =
        this.sliderItemsToShow[1].offsetTop -
        this.sliderItemsToShow[0].offsetTop;
      this.slidesPerPage = Math.floor(
        (this.slider.clientHeight - this.sliderItemsToShow[0].offsetTop) /
          this.sliderItemOffset
      );
    } else {
      this.sliderItemsToShow = Array.from(this.sliderItems).filter(
        (element) => element.clientWidth > 0
      );
      if (this.sliderItemsToShow.length < 2) return;
      this.sliderItemOffset =
        this.sliderItemsToShow[1].offsetLeft -
        this.sliderItemsToShow[0].offsetLeft;
      this.slidesPerPage = Math.floor(
        (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) /
          this.sliderItemOffset
      );
    }
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    const previousPage = this.currentPage;
    if (this.slider.classList.contains("slider--vertical")) {
      this.currentPage =
        Math.round(this.slider.scrollTop / this.sliderItemOffset) + 1;
    } else {
      this.currentPage =
        Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;
    }

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent("slideChanged", {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    if (this.enableSliderLooping) return;

    if (this.slider.classList.contains("slider--vertical")) {
      if (
        this.isSlideVisible(this.sliderItemsToShow[0]) &&
        this.slider.scrollTop === 0
      ) {
        this.prevButton.setAttribute("disabled", "disabled");
      } else {
        this.prevButton.removeAttribute("disabled");
      }
    } else {
      if (
        this.isSlideVisible(this.sliderItemsToShow[0]) &&
        this.slider.scrollLeft === 0
      ) {
        this.prevButton.setAttribute("disabled", "disabled");
      } else {
        this.prevButton.removeAttribute("disabled");
      }
    }

    if (
      this.isSlideVisible(
        this.sliderItemsToShow[this.sliderItemsToShow.length - 1]
      )
    ) {
      this.nextButton.setAttribute("disabled", "disabled");
    } else {
      this.nextButton.removeAttribute("disabled");
    }
  }

  isSlideVisible(element, offset = 0) {
    if (this.slider.classList.contains("slider--vertical")) {
      const lastVisibleSlide =
        this.slider.clientHeight + this.slider.scrollTop - offset;
      return (
        element.offsetTop + element.clientHeight <= lastVisibleSlide &&
        element.offsetTop >= this.slider.scrollTop
      );
    } else {
      const lastVisibleSlide =
        this.slider.clientWidth + this.slider.scrollLeft - offset;
      return (
        element.offsetLeft + element.clientWidth <= lastVisibleSlide &&
        element.offsetLeft >= this.slider.scrollLeft
      );
    }
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;

    if (this.slider.classList.contains("slider--vertical")) {
      this.slideScrollPosition =
        event.currentTarget.name === "next"
          ? this.slider.scrollTop + step * this.sliderItemOffset
          : this.slider.scrollTop - step * this.sliderItemOffset;
      this.slider.scrollTo({
        top: this.slideScrollPosition,
      });
    } else {
      this.slideScrollPosition =
        event.currentTarget.name === "next"
          ? this.slider.scrollLeft + step * this.sliderItemOffset
          : this.slider.scrollLeft - step * this.sliderItemOffset;
      this.slider.scrollTo({
        left: this.slideScrollPosition,
      });
    }
  }
}

customElements.define("slider-component", SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector(".slider-buttons");
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector(".slideshow__slide");
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(
      this.sliderControlWrapper.querySelectorAll(".slider-counter__link")
    );
    this.sliderControlLinksArray.forEach((link) =>
      link.addEventListener("click", this.linkToSlide.bind(this))
    );
    this.slider.addEventListener("scroll", this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute("data-autoplay") === "true")
      this.setAutoPlay();
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector(".slideshow__autoplay");
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener(
      "click",
      this.autoPlayToggle.bind(this)
    );
    this.addEventListener("mouseover", this.focusInHandling.bind(this));
    this.addEventListener("mouseleave", this.focusOutHandling.bind(this));
    this.addEventListener("focusin", this.focusInHandling.bind(this));
    this.addEventListener("focusout", this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === "previous") {
      this.slideScrollPosition =
        this.slider.scrollLeft +
        this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === "next") {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition,
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll(".slider-counter__link");
    this.prevButton.removeAttribute("disabled");

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove("slider-counter__link--active");
      link.removeAttribute("aria-current");
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add(
      "slider-counter__link--active"
    );
    this.sliderControlButtons[this.currentPage - 1].setAttribute(
      "aria-current",
      true
    );
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton =
      event.target === this.sliderAutoplayButton ||
      this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton =
      event.target === this.sliderAutoplayButton ||
      this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute("aria-live", "off");
    clearInterval(this.autoplay);
    this.autoplay = setInterval(
      this.autoRotateSlides.bind(this),
      this.autoplaySpeed
    );
  }

  pause() {
    this.slider.setAttribute("aria-live", "polite");
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add("slideshow__autoplay--paused");
      this.sliderAutoplayButton.setAttribute(
        "aria-label",
        window.accessibilityStrings.playSlideshow
      );
    } else {
      this.sliderAutoplayButton.classList.remove("slideshow__autoplay--paused");
      this.sliderAutoplayButton.setAttribute(
        "aria-label",
        window.accessibilityStrings.pauseSlideshow
      );
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length
        ? 0
        : this.slider.scrollLeft +
          this.slider.querySelector(".slideshow__slide").clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll("a");
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute("tabindex");
          });
        item.setAttribute("aria-hidden", "false");
        item.removeAttribute("tabindex");
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute("tabindex", "-1");
          });
        item.setAttribute("aria-hidden", "true");
        item.setAttribute("tabindex", "-1");
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
        (this.sliderControlLinksArray.indexOf(event.currentTarget) +
          1 -
          this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define("slideshow-component", SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("change", this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, "", false);
    this.updatePickupAvailability();
    this.removeErrorMessage();

    if (!this.currentVariant) {
      this.toggleAddButton(true, "", true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
      this.setActiveFitSize();

      // const productForm = document.getElementById(
      //   `product-form-${this.dataset.section}`
      // );
      // if (productForm) {
      //   const quantity = productForm.querySelector('[name="quantity"]');
      //   if (quantity) {
      //     alert(parseInt(quantity.value));
      //   }
      // }
    }

    const stickyAddToCart = document.querySelector('.nextdev--sticky-atc-button');
    if (stickyAddToCart != null) {
      const stickyAddToCartOptions = stickyAddToCart.querySelectorAll('.nextdev--sticky-atc-button__product-options select option');
      const options = this.currentVariant.options;

      options.forEach((option) => {
        stickyAddToCartOptions.forEach((stickyAddToCartOption) => {
          if (stickyAddToCartOption.value == option && stickyAddToCartOption.selected == false) {
            stickyAddToCartOption.selected = true;
            stickyAddToCartOption.closest('select').dispatchEvent(new Event('change', { bubbles: true }));
          }
        });
      });
    }
  }

  setActiveFitSize() {
    // Get the fit size items
    const fitSizeItems = document.querySelectorAll(".fit-size-item");

    // If there are no fit size items, exit the function early
    if (fitSizeItems.length === 0) {
      console.warn("No '.fit-size-item' elements found for this product.");
      return;
    }

    // Iterate over the fit size items and update the active class
    fitSizeItems.forEach((item) => {
      const fitSize = item.getAttribute("data-fitsize");
      if (fitSize === this.currentVariant.title) {
        item.classList.add("active_fit_size_item");
      } else {
        item.classList.remove("active_fit_size_item");
      }
    });
  }

  updateOptions() {
    this.options = Array.from(
      this.querySelectorAll("select"),
      (select) => select.value
    );
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGalleries = document.querySelectorAll(
      `[id^="MediaGallery-${this.dataset.section}"]`
    );
    mediaGalleries.forEach((mediaGallery) =>
      mediaGallery.setActiveMedia(
        `${this.dataset.section}-${this.currentVariant.featured_media.id}`,
        true
      )
    );

    const modalContent = document.querySelector(
      `#ProductModal-${this.dataset.section} .product-media-modal__content`
    );
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector(
      `[data-media-id="${this.currentVariant.featured_media.id}"]`
    );
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === "false") return;

    const url = new URL(window.location.href);
    const urlParams = new URLSearchParams(url.search);
    urlParams.delete("variant");
    let params = urlParams.toString();
    if (params != "") params = "&" + params;

    window.history.replaceState(
      {},
      "",
      `${this.dataset.url}?variant=${this.currentVariant.id}${params}`
    );
  }

  updateShareUrl() {
    const shareButton = document.getElementById(
      `Share-${this.dataset.section}`
    );
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(
      `${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector("pickup-availability");
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute("available");
      pickUpAvailability.innerHTML = "";
    }
  }

  removeErrorMessage() {
    const section = this.closest("section");
    if (!section) return;

    const productForm = section.querySelector("product-form");
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    fetch(
      `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${
        this.dataset.originalSection
          ? this.dataset.originalSection
          : this.dataset.section
      }`
    )
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, "text/html");
        const html_price = html.getElementById(`price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);

        const prices = document.querySelectorAll(`#price-${this.dataset.section}`);
        if (prices.length > 0 && html_price) {
          prices.forEach((price) => {
            price.innerHTML = html_price.innerHTML;

            const productBundleVariants = document.querySelector('.nextdev--product__bundle--variants');
            if (productBundleVariants != null) {
              const productSelectedBundleVariant = productBundleVariants.querySelector('input[name="variant_id"]:checked');
              if (productSelectedBundleVariant != null) {
                const productSelectedBundleVariantId = productSelectedBundleVariant.getAttribute('id');
                const productSelectedBundleVariantLabel = productBundleVariants.querySelector('label[for="' + productSelectedBundleVariantId + '"]');
                const productSelectedBundleVariantPrice = productSelectedBundleVariantLabel.querySelector('.nextdev--product__bundle--variant__price-amount').textContent;
                const productSelectedBundleVariantCompareAtPrice = productSelectedBundleVariantLabel.querySelector('.nextdev--product__bundle--variant__price-compare-at-price span').textContent;
                const productSelectedBundleVariantSave = productSelectedBundleVariantLabel.querySelector('.nextdev--product__bundle--variant__save span').textContent;

                price.querySelector('.price__regular .price-item.price-item--regular').textContent = productSelectedBundleVariantPrice;
                price.querySelector('.price__sale .price-item.price-item--sale.price-item--last strong').textContent = productSelectedBundleVariantPrice;
                price.querySelector('.price__sale .price-item.price-item--regular').textContent = productSelectedBundleVariantCompareAtPrice;
                price.querySelector('.badge.price__badge-sale').textContent = productSelectedBundleVariantSave;
              }
            }

            price.classList.remove('visibility-hidden');
          });
        }

        /* Start - Add To Cart Upsell Modal */
        const upsellModal = document.querySelector('.nextdev--product-upsell-modal');

        if (upsellModal != null) {
          const productImage = upsellModal.querySelector('.nextdev--product-upsell-modal--header__product--image .img-wrap');
          const productOptions = upsellModal.querySelector('.nextdev--product-upsell-modal--header__product--info__options');
          const productPrice = upsellModal.querySelector('.nextdev--product-upsell-modal--header__product--info__price');
          const productPriceAmount = productPrice.querySelector('.amount');
          const productPriceCompareAtPrice = productPrice.querySelector('.compare-at-price');
          const productPriceSave = productPrice.querySelector('.save');

          if (this.currentVariant.featured_image) {
            productImage.innerHTML = `
              <img 
                src="${this.currentVariant.featured_image.src}&crop=center&width=240&height=240" 
                alt="${this.currentVariant.title}" 
                width="240" 
                height="240" 
                decoding="async" 
                class="lazy-img" 
                draggable="false"
              >
            `;
          }

          productOptions.innerText = this.currentVariant.title;
          productPriceAmount.innerText = Shopify.formatMoney(this.currentVariant.price, 'amount_no_decimals');
          if (productPriceCompareAtPrice != null) {
            productPriceCompareAtPrice.innerText = Shopify.formatMoney(this.currentVariant.compare_at_price, 'amount_no_decimals');
          }
          if (productPriceSave != null) {
            productPriceSave.innerText = `You saved ${Shopify.formatMoney((this.currentVariant.compare_at_price - this.currentVariant.price), 'amount_no_decimals')}`;
          }
        }
        /* End - Add To Cart Upsell Modal */

        // const docBody = document.body;
        // if (docBody.classList.contains('product-luxurious-cozy-car-bed-bo-wrap')) {
        //   const lcbBogoBundle = document.querySelector('.nextdev--product__bundle');
        //   const lcbBogoBundleVariants = lcbBogoBundle.querySelectorAll('.nextdev--product__bundle--variant');

        //   let productVariantCompareAtPrice = this.currentVariant.compare_at_price;
        //   let productVariantPrice = this.currentVariant.price;

        //   lcbBogoBundleVariants.forEach((lcbBogoBundleVariant, index) => {
        //     const lcbBogoBundleVariantPrice = lcbBogoBundleVariant.querySelector('.nextdev--product__bundle--variant__price');
        //     const lcbBogoBundleVariantPriceOld = lcbBogoBundleVariantPrice.querySelector('.nextdev--product__bundle--variant__price--old');
        //     const lcbBogoBundleVariantPriceAmount = lcbBogoBundleVariantPrice.querySelector('.nextdev--product__bundle--variant__price--amount');

        //     if (index == 1) {
        //       productVariantCompareAtPrice = productVariantCompareAtPrice * 2;
        //       productVariantPrice = productVariantPrice * 2;
        //     }

        //     if (lcbBogoBundleVariantPriceOld != null) {
        //       lcbBogoBundleVariantPriceOld.querySelector('span').textContent = Shopify.formatMoney(productVariantCompareAtPrice, 'amount_no_decimals');
        //     }
        //     lcbBogoBundleVariantPriceAmount.textContent = Shopify.formatMoney(productVariantPrice, 'amount_no_decimals');
        //   });
        // }

        this.toggleAddButton(
          !this.currentVariant.available,
          window.variantStrings.soldOut
        );

        const destination_badge = document.getElementById(
          `badge-${this.dataset.section}`
        );
        const source_badge = html.getElementById(
          `badge-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        );
        if (source_badge && destination_badge) destination_badge.innerHTML = source_badge.innerHTML;

        const badge = document.getElementById(`badge-${this.dataset.section}`);

        if (badge) badge.classList.remove("visibility-hidden");

        const destination_customQuantitySelector = document.getElementById(
          `product__custom-quantity-selector-${this.dataset.section}`
        );
        const source_customQuantitySelector = html.getElementById(
          `product__custom-quantity-selector-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        );
        if (source_customQuantitySelector && destination_customQuantitySelector) {
          const coolingMatBundles = document.querySelector('input[data-product-handle="pelsbarn-cooling-mat-bundles"]');

          if (coolingMatBundles != null) {
            const giftsMainBlocks = document.querySelectorAll(".gifts-main-block");

            destination_customQuantitySelector.innerHTML = source_customQuantitySelector.innerHTML;

            const customQuantitySelector = document.querySelector('#product__custom-quantity-selector-' + this.dataset.section);
            const customQuantitySelectorSelected = customQuantitySelector.closest('.product__custom-quantity-selector').querySelector('.product__custom-quantity-selector--selected span');
            const customQuantityBoxes = customQuantitySelector.querySelectorAll('.product__custom-quantity-selector--box');
            customQuantityBoxes.forEach((customQuantityBox) => {
              const customQuantityBoxTitle = customQuantityBox.querySelector('.product__custom-quantity-selector--info__title');
              const customQuantityBoxPrice = customQuantityBox.querySelector('.product__custom-quantity-selector--regular-price');
              const customQuantityBoxCheckbox = customQuantityBox.querySelector('input');

              if (customQuantityBoxTitle.innerText == customQuantitySelectorSelected.innerText) {
                customQuantityBoxCheckbox.checked = true;

                let quantity = '1';
                if (customQuantityBoxCheckbox.getAttribute('id').indexOf('_2') != -1) {
                  quantity = '2';
                } else if (customQuantityBoxCheckbox.getAttribute('id').indexOf('_3') != -1) {
                  quantity = '3';
                }
                coolingMatBundles.value = "x" + quantity + " - Pelsbarn Cooling Mat (" + this.currentVariant.title + ")";

                if (giftsMainBlocks.length > 0) {
                  giftsMainBlocks.forEach((giftsMainBlock) => {
                    const giftValues = giftsMainBlock.querySelectorAll(".gifts-image-container strong");

                    if (giftValues.length > 0) {
                      giftValues.forEach((giftValue) => {
                        giftValue.innerText = customQuantityBoxPrice.innerText;
                      });
                    }
                  });
                }
              }

              customQuantityBoxCheckbox.addEventListener('change', () => {
                customQuantitySelectorSelected.innerText = customQuantityBoxTitle.innerText;

                if (giftsMainBlocks.length > 0) {
                  giftsMainBlocks.forEach((giftsMainBlock) => {
                    const giftValues = giftsMainBlock.querySelectorAll(".gifts-image-container strong");

                    if (giftValues.length > 0) {
                      giftValues.forEach((giftValue) => {
                        giftValue.innerText = customQuantityBoxPrice.innerText;
                      });
                    }
                  });
                }
              });
            });
          } else {
            const customQuantitySelector = document.querySelector('#product__custom-quantity-selector-' + this.dataset.section);
            const customQuantitySelectorSelected = customQuantitySelector.closest('.product__custom-quantity-selector').querySelector('.product__custom-quantity-selector--selected span');
            const customQuantityBoxes = customQuantitySelector.querySelectorAll('.product__custom-quantity-selector--box');
            const customQuantityBoxTotalValue = customQuantitySelector.querySelector('.product__custom-quantity-selector--box__total-value span');
            const customQuantityBoxTotalPay = customQuantitySelector.querySelector('.product__custom-quantity-selector--box__total-pay span');
            const customQuantityBoxTotalSave = customQuantitySelector.querySelector('.product__custom-quantity-selector--box__total-save span');

            customQuantityBoxes.forEach((customQuantityBox) => {
              const customQuantityBoxCheckbox = customQuantityBox.querySelector('input');
              const customQuantityBoxTitle = customQuantityBox.querySelector('.product__custom-quantity-selector--info__title');
              const customQuantityBoxPrice = customQuantityBox.querySelector('.product__custom-quantity-selector--regular-price');
              const customQuantityBoxSalePrice = customQuantityBox.querySelector('.product__custom-quantity-selector--sale-price');
              const customQuantityBoxSave = customQuantityBox.querySelector('.product__custom-quantity-selector--info__title--save-badge');
              
              customQuantityBoxCheckbox.addEventListener('change', () => {
                if (customQuantitySelectorSelected != null) {
                  customQuantitySelectorSelected.innerText = customQuantityBoxTitle.innerText;
                }

                if (customQuantityBoxSave != null) {
                  customQuantityBoxTotalValue.textContent = customQuantityBoxSalePrice.textContent;
                  customQuantityBoxTotalPay.textContent = customQuantityBoxPrice.textContent;
                  customQuantityBoxTotalSave.textContent = customQuantityBoxSave.textContent;
                }
              });
            });
          }
        } else {
          const giftsMainBlocks = document.querySelectorAll(".gifts-main-block");
          if (giftsMainBlocks.length > 0) {
            giftsMainBlocks.forEach((giftsMainBlock) => {
              const giftValues = giftsMainBlock.querySelectorAll(
                ".gifts-image-container strong"
              );
              if (giftValues.length > 0) {
                giftValues.forEach((giftValue) => {
                  giftValue.innerText = Shopify.formatMoney(
                    this.currentVariant.price,
                    "amount_no_decimals"
                  );
                });
              }
            });
          }
        }

        const teddySofaBedBogo = document.querySelector(
          'input[data-product-handle="pelsbarn-teddy-sofa-bed-1-1"]'
        );
        const realOrthopedicBedBogo = document.querySelector(
          'input[data-product-handle="real-orthopedic-bed-for-dogs-bogo"]'
        );
        const luxuriousOrthopedicBedBogo = document.querySelector(
          'input[data-product-handle="luxurious-orthopedic-bed-bogo"]'
        );
        const protectingCarBedBogo = document.querySelector(
          'input[data-product-handle="car-bed-2-bogo"]'
        );
        const luxuriousCozyBedBogo2 = document.querySelector(
          'input[data-product-handle="luxurious-cozy-car-bed-1-1-2"]'
        );
        const luxuriousSofaBedBogo2 = document.querySelector(
          'input[data-product-handle="pelsbarn-luxurious-sofa-bed-1-1-2"]'
        );
        const luxuriousSofaBedBogo3 = document.querySelector(
          'input[data-product-handle="pelsbarn-luxurious-sofa-bed-1-3"]'
        );
        const coolingMatBundle = document.querySelector(
          'input[data-product-handle="pelsbarn-cooling-mat-bundle"]'
        );
        const coolingMatBundle2 = document.querySelector(
          'input[data-product-handle="cooling-mat-bogo-b"]'
        );
        const coolingCarBundle = document.querySelector(
          'input[data-product-handle="pelsbarn-cooling-car-bed-bogo-deal"]'
        );
        const coolingSofaBundle = document.querySelector(
          'input[data-product-handle="pelsbarn-cooling-bed-4x-more-effective-bogo-deal"]'
        );
        const luxuriousDonutBogo = document.querySelector(
          'input[data-product-handle="luxurious-donut-bed-1-1"]'
        );

        if (teddySofaBedBogo != null) {
          teddySofaBedBogo.value =
            "Teddy Sofa Bed (" + this.currentVariant.title + ")";
        } else if (realOrthopedicBedBogo != null) {
          realOrthopedicBedBogo.value =
            "Real Orthopedic Bed (" + this.currentVariant.title + ")";
        } else if (luxuriousOrthopedicBedBogo != null) {
          luxuriousOrthopedicBedBogo.value =
            "Luxurious Orthopedic Bed (" + this.currentVariant.title + ")";
        } else if (protectingCarBedBogo != null) {
          protectingCarBedBogo.value =
            "Protecting Car Bed (" + this.currentVariant.title + ")";
        } else if (luxuriousCozyBedBogo2 != null) {
          luxuriousCozyBedBogo2.value =
            "Luxurious Car Bed (" + this.currentVariant.title + ")";
        } else if (luxuriousSofaBedBogo2 != null) {
          luxuriousSofaBedBogo2.value =
            "Luxurious Sofa Bed (" + this.currentVariant.title + ")";
        } else if (luxuriousSofaBedBogo3 != null) {
          luxuriousSofaBedBogo3.value =
            "Luxurious Sofa Bed (" + this.currentVariant.title + ")";
        } else if (coolingMatBundle != null) {
          coolingMatBundle.value =
            "Pelsbarn Cooling Mat (" + this.currentVariant.title + ")";
        } else if (coolingMatBundle2 != null) {
          coolingMatBundle2.value =
            "Pelsbarn Cooling Mat (" + this.currentVariant.title + ")";
        } else if (coolingCarBundle != null) {
          coolingCarBundle.value =
            "Cooling Car Bed (" + this.currentVariant.title + ")";
        } else if (coolingSofaBundle != null) {
          coolingSofaBundle.value =
            "Cooling Sofa Bed (" + this.currentVariant.title + ")";
        } else if (luxuriousDonutBogo != null) {
          luxuriousDonutBogo.value =
            "Luxurious Donut Bed (" + this.currentVariant.title + ")";
        }

        const bundleProducts = document.querySelectorAll(
          ".product__bundle .product__bundle-product"
        );
        if (bundleProducts.length > 0) {
          let currentVariantOptions = this.currentVariant.options;
          currentVariantOptions = currentVariantOptions.map((str) =>
            str.toLowerCase()
          );

          bundleProducts.forEach((bundleProduct) => {
            const bundleProductOptions = bundleProduct.querySelectorAll(
              ".product__bundle-product--info-details-options .product__bundle-product--info-details-option select option"
            );

            bundleProductOptions.forEach((bundleProductOption) => {
              const optionValue = bundleProductOption.getAttribute("value");

              if (currentVariantOptions.includes(optionValue.toLowerCase())) {
                const selectOption = bundleProductOption
                  .closest("select")
                  .querySelector('option[value="' + optionValue + '"]');
                selectOption.selected = true;
              }
            });
          });
        }

        const variantTitle = this.currentVariant.title;
        const newColorOption = document.querySelector('.new-color-option');
        if (newColorOption != null) {
          if (variantTitle.indexOf('Forest Green') != -1 || variantTitle == 'M/L / Beige' || variantTitle == 'M/L / Latte Swirl') {
            newColorOption.classList.remove('hidden');
          } else {
            newColorOption.classList.add('hidden');
          }
        }
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    if (!productForm) return;

    const addButtons = productForm.querySelectorAll('[name="add"]');
    if (addButtons.length > 0) {
      addButtons.forEach(addButton => {
        if (addButton.classList.contains('nextdev--add-cart')) return;

        const addButtonText = addButton.querySelector('span');

        if (disable) {
          addButton.setAttribute("disabled", "disabled");

          if (this.currentVariant.id == 58355183452543 || this.currentVariant.id == 58408887157119) {
            text = 'Unavailable';
          }

          if (text) addButtonText.textContent = text;
        } else {
          addButton.removeAttribute("disabled");

          const addButtonContent = addButton.hasAttribute('data-pre-order') ? 'Pre-Order' : window.variantStrings.addToCart;

          addButtonText.innerHTML = `
            <div>${addButtonContent}</div>
            <div class="product-form__submit-subtext">
              <div class="product-form__submit-subtext">
                <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>
                  <polyline points="9 12 11 14 15 10"></polyline>
                </svg>
                14-Day Returns • 1-Year Warranty
              </div>
            </div>
          `;
        }
      });
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const productForm = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    if (!productForm) return;

    const addButtons = productForm.querySelectorAll('[name="add"]');
    if (addButtons.length > 0) {
      addButtons.forEach(addButton => {
        if (addButton.classList.contains('nextdev--add-cart')) return;
        const addButtonText = addButton.querySelector('span');
        addButtonText.textContent = window.variantStrings.unavailable;
      });
    }

    const prices = document.querySelectorAll(`#price-${this.dataset.section}`);
    if (prices.length > 0) {
      prices.forEach((price) => {
        price.classList.add('visibility-hidden');
      });
    }

    const badge = document.getElementById(`badge-${this.dataset.section}`);
    if (badge) badge.classList.add("visibility-hidden");
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define("variant-selects", VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll("fieldset"));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll("input")).find(
        (radio) => radio.checked
      ).value;
    });

    var option_name = document.querySelectorAll(
      ".option_name .option_selected_value_cover"
    );
    if (option_name.length > 0) {
      this.options.forEach(function (item, index) {
        option_name[index].innerHTML = item;
      });
    }
  }
}

customElements.define("variant-radios", VariantRadios);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement("div");
          html.innerHTML = text;
          const recommendations = html.querySelector("product-recommendations");

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (
            !this.querySelector("slideshow-component") &&
            this.classList.contains("complementary-products")
          ) {
            this.remove();
          }

          if (html.querySelector(".grid__item")) {
            this.classList.add("product-recommendations--loaded");
          }
        })
        .catch((e) => {
          console.error(e);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}

customElements.define("product-recommendations", ProductRecommendations);

/* Start - Custom Code */
document.addEventListener("DOMContentLoaded", () => {
  /* Start - Scroll To Element */
  const scrollToLinks = document.querySelectorAll('a[href*="#"]');

  if (scrollToLinks.length > 0) {
    scrollToLinks.forEach((scrollToLink) => {
      const href = scrollToLink.getAttribute("href");

      if (href != "#" && href.charAt(0) == "#") {
        const element = document.querySelector(href);

        if (element != null) {
          scrollToLink.addEventListener("click", (e) => {
            e.stopPropagation();
            e.preventDefault();

            element.scrollIntoView({
              behavior: "smooth",
              block: "start",
              inline: "nearest",
            });

            // a target that can take focus takes it, so the skip link puts
            // a keyboard in the main content and not back in the header
            if (element.hasAttribute("tabindex")) {
              element.focus({ preventScroll: true });
            }

            return false;
          });
        }
      }
    });
  }
  /* End - Scroll To Element */

  /* Start - Product Page Upsell */
  const productUpsellInfo = document.querySelector(".product__upsell-info");

  if (productUpsellInfo != null) {
    const productUpsellInfoHeading = productUpsellInfo.querySelector(
      ".product__upsell-info--heading"
    );
    const productUpsellInfoDescription = productUpsellInfo.querySelector(
      ".product__upsell-info--description"
    );

    productUpsellInfoHeading.addEventListener("click", () => {
      productUpsellInfo.classList.toggle("active");
      productUpsellInfoDescription.scrollIntoView({
        behavior: "smooth",
        block: "start",
        inline: "nearest",
      });
    });
  }
  /* End - Product Page Upsell */

  /* Start - Countdown Timer */
  const countdownTimers = document.querySelectorAll(".countdown-timer");
  if (countdownTimers.length > 0) {
    let deadline = new Date();
    deadline.setHours(23, 59, 59, 999);
    deadline = deadline.getTime();

    setInterval(() => {
      const now = new Date().getTime();
      const t = deadline - now;

      const days = Math.floor(t / (1000 * 60 * 60 * 24));
      const hours = Math.floor((t % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((t % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((t % (1000 * 60)) / 1000);

      let text =
        (hours <= 9 ? "0" + hours : hours) +
        ":" +
        (minutes <= 9 ? "0" + minutes : minutes) +
        ":" +
        (seconds <= 9 ? "0" + seconds : seconds);
      if (days > 0) {
        text = (days <= 9 ? "0" + days : days) + ":" + text;
      }

      countdownTimers.forEach((countdownTimer) => {
        const timer = countdownTimer.querySelector(".timer");
        // const timerHours = timer.querySelector('.timer-hours');
        // const timerMinutes = timer.querySelector('.timer-minutes');
        // const timerSeconds = timer.querySelector('.timer-seconds');

        if (timer != null) {
          timer.innerText = text;

          // timerHours.innerText = (hours <= 9 ? '0' + hours : hours);
          // timerMinutes.innerText = (minutes <= 9 ? '0' + minutes : minutes);
          // timerSeconds.innerText = (seconds <= 9 ? '0' + seconds : seconds);
        }
      });

      if (t <= 1000) {
        deadline = new Date();
        deadline.setHours(23, 59, 59, 999);
        deadline = deadline.getTime();
      }
    }, 1000);
  }
  /* End - Countdown Timer */

  /* Start - Product Page Sticky Add To Cart */
  const stickyAddToCart = document.querySelector(
    ".alphadev-sticky-add-to-cart"
  );

  if (stickyAddToCart != null) {
    const stickyAddToCartButton = stickyAddToCart.querySelector(
      ".alphadev-sticky-add-to-cart--button .button"
    );
    const stickyAddToCartButtonText =
      stickyAddToCartButton.querySelector(".text");
    const stickyAddToCartButtonLoading = stickyAddToCartButton.querySelector(
      ".loading-overlay__spinner"
    );

    stickyAddToCartButton.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopPropagation();

      stickyAddToCartButton.disabled = true;
      stickyAddToCartButtonLoading.classList.remove("hidden");
      stickyAddToCartButtonText.classList.add("hidden");

      const productForm = document.querySelector(
        '.product-form form button[name="add"]'
      );
      productForm.dispatchEvent(new Event("click"));

      setTimeout(() => {
        stickyAddToCartButtonText.classList.remove("hidden");
        stickyAddToCartButtonLoading.classList.add("hidden");
        stickyAddToCartButton.disabled = false;
      }, 2000);
    });
  }
  /* End - Product Page Sticky Add To Cart */

  /* Start - Custom Add To Cart */
  const addToCartLinks = document.querySelectorAll(".custom-add-to-cart");

  if (addToCartLinks.length > 0) {
    addToCartLinks.forEach((link) => {
      link.addEventListener("click", function () {
        document.querySelector(".product-form__submit").click();
      });
    });
  }
  /* End - Custom Add To Cart */

  /* Start - Stamped Reviews Custom Featrures */
  function timeAgo(dateString) {
    const [month, day, year] = dateString.split("/").map(Number);

    const inputDate = new Date(year, month - 1, day);
    const now = new Date();

    const diffMs = now - inputDate;

    if (diffMs < 0) {
      return "in the future";
    }

    const diffHours = Math.floor(diffMs / (1000 * 60 * 60));
    const diffDays = Math.floor(diffHours / 24);
    const diffWeeks = Math.floor(diffDays / 7);

    if (diffHours < 24) {
      return diffHours === 1
        ? "1 hour ago"
        : `${diffHours} hours ago`;
    }

    if (diffDays < 7) {
      return diffDays === 1
        ? "1 day ago"
        : `${diffDays} days ago`;
    }

    return diffWeeks === 1
      ? "1 week ago"
      : `${diffWeeks} weeks ago`;
  }

  const recommendedThisProduct = `<div class="stamped-review-recommend-this-product">
    <strong>93%</strong> 
    <span>would recommend this product</span>
  </div>`;
  const recommendedMessage = `<div class="stamped-review-recommend-custom">
    <span class="stamped-review-recommend-custom--icon"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" d="M23 10a2 2 0 0 0-2-2h-6.32l.96-4.57c.02-.1.03-.21.03-.32c0-.41-.17-.79-.44-1.06L14.17 1L7.59 7.58C7.22 7.95 7 8.45 7 9v10a2 2 0 0 0 2 2h9c.83 0 1.54-.5 1.84-1.22l3.02-7.05c.09-.23.14-.47.14-.73zM1 21h4V9H1z"/></svg></span>
    <span class="stamped-review-recommend-custom--text">I recommend this product</span>
  </div>`;
  /*const verifiedMessage = `<div class="stamped-review-verified">
    <span class="stamped-review-verified--text">Verified by</span>
    <span class="stamped-review-verified--icon">
      <svg width="101" height="42" viewBox="0 0 101 42" fill="none" xmlns="http://www.w3.org/2000/svg" class="h-space-24 w-[auto] lg:h-[30px] lg:w-[auto] transform-gpu text-text-brand"><title>Shop</title><path d="M12.0288 18.2598C7.97006 17.3793 6.16191 17.0348 6.16191 15.4708C6.16191 13.9997 7.38555 13.2669 9.83283 13.2669C11.9851 13.2669 13.5584 14.2075 14.7165 16.0504C14.8039 16.1926 14.9841 16.2418 15.1316 16.1653L19.6984 13.8575C19.8623 13.7755 19.9224 13.5677 19.8295 13.4091C17.934 10.1224 14.4324 8.32324 9.82191 8.32324C3.76379 8.32324 0 11.3091 0 16.0559C0 21.098 4.58319 22.3722 8.64743 23.2527C12.7117 24.1331 14.5253 24.4776 14.5253 26.0417C14.5253 27.6057 13.2033 28.344 10.5648 28.344C8.12848 28.344 6.32033 27.2284 5.22779 25.0628C5.14585 24.9042 4.95466 24.8386 4.79624 24.9206L0.240358 27.1791C0.0819403 27.2612 0.0163881 27.4526 0.0983284 27.6166C1.90648 31.2533 5.61564 33.2986 10.5703 33.2986C16.8797 33.2986 20.6927 30.3619 20.6927 25.4675C20.6927 20.573 16.0876 19.1512 12.0288 18.2707V18.2598Z" fill="currentColor"></path><path d="M36.5018 8.32341C33.9125 8.32341 31.6236 9.24214 29.9794 10.8773C29.8756 10.9757 29.7062 10.9046 29.7062 10.7624V0.322772C29.7062 0.142307 29.5642 0.00012207 29.3839 0.00012207H23.67C23.4897 0.00012207 23.3477 0.142307 23.3477 0.322772V32.7245C23.3477 32.905 23.4897 33.0472 23.67 33.0472H29.3839C29.5642 33.0472 29.7062 32.905 29.7062 32.7245V18.5115C29.7062 15.7662 31.8094 13.6608 34.6445 13.6608C37.4796 13.6608 39.5336 15.7225 39.5336 18.5115V32.7245C39.5336 32.905 39.6756 33.0472 39.8559 33.0472H45.5699C45.7501 33.0472 45.8922 32.905 45.8922 32.7245V18.5115C45.8922 12.5397 41.9809 8.32887 36.5018 8.32887V8.32341Z" fill="currentColor"></path><path d="M57.4962 7.39915C54.3934 7.39915 51.4764 8.34522 49.3896 9.71785C49.2476 9.81082 49.1984 10.0022 49.2858 10.1499L51.8041 14.4537C51.897 14.6068 52.0937 14.6615 52.2466 14.5685C53.8308 13.6115 55.6444 13.1139 57.4962 13.1248C62.4837 13.1248 66.1491 16.6466 66.1491 21.3005C66.1491 25.2652 63.2157 28.2019 59.4956 28.2019C56.4638 28.2019 54.3607 26.4355 54.3607 23.9418C54.3607 22.5145 54.967 21.3442 56.5457 20.5184C56.7096 20.4309 56.7697 20.2286 56.6714 20.07L54.2951 16.0451C54.2186 15.9138 54.0548 15.8537 53.9073 15.9084C50.7225 17.0896 48.4883 19.9333 48.4883 23.7504C48.4883 29.5253 53.0824 33.8346 59.4901 33.8346C66.974 33.8346 72.3548 28.6448 72.3548 21.202C72.3548 13.2233 66.0945 7.39368 57.4853 7.39368L57.4962 7.39915Z" fill="currentColor"></path><path d="M89.0635 8.27964C86.1738 8.27964 83.5954 9.34603 81.7108 11.2272C81.607 11.3311 81.4376 11.2546 81.4376 11.1124V8.84838C81.4376 8.66791 81.2956 8.52573 81.1153 8.52573H75.5489C75.3686 8.52573 75.2266 8.66791 75.2266 8.84838V41.2009C75.2266 41.3814 75.3686 41.5236 75.5489 41.5236H81.2628C81.4431 41.5236 81.5851 41.3814 81.5851 41.2009V30.5917C81.5851 30.4495 81.7545 30.3784 81.8583 30.4714C83.7374 32.2214 86.2229 33.244 89.069 33.244C95.7717 33.244 101 27.8137 101 20.7591C101 13.7045 95.7663 8.27417 89.069 8.27417L89.0635 8.27964ZM87.9874 27.7644C84.1744 27.7644 81.2847 24.7293 81.2847 20.7153C81.2847 16.7014 84.169 13.6663 87.9874 13.6663C91.8058 13.6663 94.6846 16.6521 94.6846 20.7153C94.6846 24.7786 91.844 27.7644 87.9819 27.7644H87.9874Z" fill="currentColor"></path></svg>
    </span>
  </div>`;*/

  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        if (!(node instanceof HTMLElement)) continue;

        const stampedHeaders = node.matches(".stamped-header")
          ? [node]
          : node.querySelectorAll(".stamped-header");

        stampedHeaders.forEach((header) => {
          if (header.dataset.recommendedInjected) return;

          const recommendedThisProductElement = document.createElement("div");
          recommendedThisProductElement.innerHTML = recommendedThisProduct;

          header.append(recommendedThisProductElement);

          header.dataset.recommendedInjected = "true";
        });

        const reviewsTab = node.id === "stamped-reviews-tab"
          ? node
          : node.querySelector("#stamped-reviews-tab");

        if (!reviewsTab) continue;

        reviewsTab
          .querySelectorAll(".stamped-review-header .created")
          .forEach((date) => {
            if (date.dataset.timeagoApplied) return;

            date.innerText = timeAgo(date.innerText);

            date.dataset.timeagoApplied = "true";
          });

        reviewsTab
          .querySelectorAll('.review-location [data-location="US"]')
          .forEach((location) => {
            if (location.dataset.flagInjected) return;

            location.insertAdjacentHTML(
              "beforebegin",
              '<span class="review-location__flag" aria-hidden="true">🇺🇸</span> '
            );

            location.dataset.flagInjected = "true";
          });

        reviewsTab
          .querySelectorAll(".stamped-review-recommend")
          .forEach((recommended) => {
            if (recommended.dataset.recommendApplied) return;

            recommended.innerHTML = recommendedMessage;
            recommended.style.setProperty("display", "block", "important");

            recommended.dataset.recommendApplied = "true";
          });

        /*reviewsTab
          .querySelectorAll(".stamped-review-footer")
          .forEach((footer) => {
            if (footer.dataset.verifiedInjected) return;

            const verifiedElement = document.createElement("div");
            verifiedElement.innerHTML = verifiedMessage;

            footer.prepend(verifiedElement);

            footer.dataset.verifiedInjected = "true";
          });*/
      }
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
  /* End - Stamped Reviews Custom Featrures */

  /* Start - Q/A Section */
  const questions = document.querySelectorAll(".alphadev-qa--question");

  if (questions.length > 0) {
    questions.forEach((question) => {
      const questionsSection = question.closest(".alphadev-qa");
      const answers = question.querySelectorAll(
        ".alphadev-qa--question-answers a"
      );

      if (answers.length > 0) {
        answers.forEach((answer) => {
          answer.addEventListener("click", (e) => {
            const href = e.currentTarget.getAttribute("href");

            if (href.indexOf("#") != -1) {
              const nextQuestion = href.replace("#", "");
              const checkNextQuestion = questionsSection.querySelector(
                '.alphadev-qa--question[data-position="' + nextQuestion + '"]'
              );

              if (checkNextQuestion != null) {
                e.preventDefault();

                question.classList.add("hidden");
                checkNextQuestion.classList.remove("hidden");
              }
            }
          });
        });
      }
    });
  }
  /* End - Q/A Section */

  /* Start - Product Page Upsell Slider */
  const productUpsellSlider = document.querySelector(".product__upsell-slider");

  if (productUpsellSlider != null) {
    const productUpsellSliderButtons = productUpsellSlider.querySelectorAll(
      ".product__upsell-slider-atc .button"
    );

    if (productUpsellSliderButtons.length > 0) {
      if (document.querySelector(".swiper--upsell-slider") != null) {
        new Swiper(".swiper--upsell-slider", {
          slidesPerView: "auto",
          spaceBetween: 10,
        });
      }

      productUpsellSliderButtons.forEach((productUpsellSliderButton) => {
        productUpsellSliderButton.addEventListener("click", (e) => {
          e.preventDefault();

          const target = e.currentTarget;
          const text = target.querySelector("span");

          if (target.classList.contains("button--active")) {
            target.classList.remove("button--active");
            text.innerText = "Add";
          } else {
            target.classList.add("button--active");
            text.innerText = "Added";
          }
        });
      });
    }
  }
  /* End - Product Page Upsell Slider */

  /* Start - Product Page Sidebar */
  const productPageSidebar = document.querySelector(".product-sidebar--drawer");

  if (productPageSidebar != null) {
    const productPageSidebarButton = document.querySelector(
      ".product-sidebar--button"
    );
    const productPageSidebarClose =
      productPageSidebar.querySelector(".drawer__close");
    const productPageSidebarOverlay = productPageSidebar.querySelector(
      ".product-sidebar--overlay"
    );

    productPageSidebarButton.addEventListener("click", (e) => {
      productPageSidebar.classList.add("active");
    });

    productPageSidebarClose.addEventListener("click", (e) => {
      productPageSidebar.classList.remove("active");
    });

    productPageSidebarOverlay.addEventListener("click", (e) => {
      productPageSidebar.classList.remove("active");
    });

    const productPageSidebarStickyCarousel = document.querySelector(
      ".product-sidebar--sticky-carousel"
    );
    if (productPageSidebarStickyCarousel != null) {
      new Swiper(".swiper--sidebar-sticky-carousel", {
        slidesPerView: 1,
        autoplay: true,
        loop: true,

        mousewheel: {
          forceToAxis: true,
        },
      });
    }
  }
  /* End - Product Page Sidebar */

  /* Start - Product Page Bundle Products */
  const bundleProducts = document.querySelectorAll(
    ".product__bundle .product__bundle-product"
  );

  if (bundleProducts.length > 0) {
    bundleProducts.forEach((bundleProduct) => {
      const bundleProductVariants = JSON.parse(
        bundleProduct.querySelector("[data-variants]").textContent
      );
      const bundleProductOptions = bundleProduct.querySelectorAll(
        ".product__bundle-product--info-details-options .product__bundle-product--info-details-option select"
      );
      const bundleProductId = bundleProduct.querySelector(
        '[name="bundle_products"]'
      );
      const bundleProductImage = bundleProduct.querySelector(
        ".product__bundle-product--info-image img"
      );

      bundleProductOptions.forEach((bundleProductOption) => {
        bundleProductOption.addEventListener("change", (e) => {
          const bundleProductSelectedOptions = bundleProduct.querySelectorAll(
            ".product__bundle-product--info-details-options .product__bundle-product--info-details-option select"
          );
          let selectedOptions = [];

          if (bundleProductSelectedOptions[0] != undefined) {
            selectedOptions.push(bundleProductSelectedOptions[0].value);
          }
          if (bundleProductSelectedOptions[1] != undefined) {
            selectedOptions.push(bundleProductSelectedOptions[1].value);
          }
          if (bundleProductSelectedOptions[2] != undefined) {
            selectedOptions.push(bundleProductSelectedOptions[2].value);
          }

          bundleProductVariants.forEach((bundleProductVariant) => {
            const variantOptions = bundleProductVariant.options;
            if (
              variantOptions.every(
                (value, index) => value === selectedOptions[index]
              )
            ) {
              bundleProductId.value = bundleProductVariant.id;

              if (bundleProductVariant.featured_image != null) {
                bundleProductImage.setAttribute(
                  "src",
                  bundleProductVariant.featured_image.src
                );
              }
            }
          });
        });
      });
    });
  }
  /* End - Product Page Bundle Products */

  /* Start - Landing Page Add to Cart */
  const lpAddToCarts = document.querySelectorAll("[data-add-to-cart]");
  if (lpAddToCarts.length > 0) {
    lpAddToCarts.forEach((lpAddToCart) => {
      lpAddToCart.addEventListener("click", (e) => {
        e.preventDefault();

        const button = e.currentTarget;
        button.classList.add("disabled");

        const button_loading = button.querySelector(
          ".loading-overlay__spinner"
        );
        if (button_loading != null) {
          button.querySelector("span").classList.add("hidden");
          button_loading.classList.remove("hidden");
        }

        const variant_id = button.getAttribute("data-add-to-cart");
        fetch("/cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            id: variant_id,
            quantity: 1,
          }),
        })
          .then((response) => response.json())
          .then((data) => {
            window.location.href = "/checkout";
          })
          .catch((error) => {
            console.error("Error adding to cart:", error);
          });
      });
    });
  }
  /* End - Landing Page Add to Cart */

  /* Start - Custom Add to Cart */
  const customAddToCartButtons = document.querySelectorAll("button[data-id]");

  if (customAddToCartButtons.length > 0) {
    customAddToCartButtons.forEach((customAddToCartButton) => {
      customAddToCartButton.addEventListener("click", (e) => {
        e.preventDefault();

        const button = e.currentTarget;

        if (button.getAttribute("aria-disabled") === "true") return;

        const buttonLoading = button.querySelector(".loading-overlay__spinner");

        button.setAttribute("aria-disabled", true);
        button.classList.add("loading");
        if (buttonLoading != null) {
          buttonLoading.classList.remove("hidden");
        }

        const variant_id = button.dataset.id;
        const cart =
          document.querySelector("cart-notification") ||
          document.querySelector("cart-drawer");

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        const formData = new FormData();
        if (cart) {
          formData.append(
            "sections",
            cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append("sections_url", window.location.pathname);
          cart.setActiveElement(document.activeElement);
        }
        formData.append("id", variant_id);
        formData.append("quantity", 1);
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => {
            checkCartItems();
            return response.json();
          })
          .then((response) => {
            if (response.status) {
              button.setAttribute("aria-disabled", true);
              button.querySelector("span").classList.add("hidden");

              return;
            } else if (!cart) {
              window.location = window.routes.cart_url;

              return;
            }

            cart.renderContents(response);
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            button.classList.remove("loading");

            if (cart && cart.classList.contains("is-empty"))
              cart.classList.remove("is-empty");

            button.setAttribute("aria-disabled", false);
            if (buttonLoading != null) {
              buttonLoading.classList.add("hidden");
            }
          });
      });
    });
  }
  /* End - Custom Add to Cart */

  /* Start - Product View Count */
  const viewCount = document.querySelector('.product__view-count');

  if (viewCount != null) {
    const viewCountBlock = viewCount.dataset.block;
    const viewCountText = viewCount.querySelector('.product__view-count--badge__views');

    const cookieViews = getCookie(viewCountBlock);
    let mainNumber = Math.floor(Math.random() * (3000 - 1000 + 1)) + 1000;
    if (cookieViews != null) {
      mainNumber = parseInt(cookieViews);
    }
    let maxOffset = Math.floor(Math.random() * (300 - 100 + 1)) + 100;
    let minViews = Math.max(1000, mainNumber - maxOffset);
    let maxViews = Math.min(3000, mainNumber + maxOffset);
    let views = Math.floor(Math.random() * (maxViews - minViews + 1)) + minViews;

    const deadlineTime = new Date(new Date().getTime() + 1 * 60 * 60 * 1000); // 1 hours
    deadline = deadlineTime.getTime();
    setCookie(viewCountBlock, views, deadlineTime.toUTCString());

    viewCountText.innerText = views;
    viewCount.classList.remove('hidden');

    setInterval(() => {
      viewCountText.classList.remove('fadeIn');

      mainNumber = parseInt(viewCountText.innerText);
      maxOffset = Math.floor(Math.random() * (300 - 100 + 1)) + 100;
      minViews = Math.max(1000, mainNumber - maxOffset);
      maxViews = Math.min(3000, mainNumber + maxOffset);
      views = Math.floor(Math.random() * (maxViews - minViews + 1)) + minViews;

      setCookie(viewCountBlock, views, deadlineTime.toUTCString());

      viewCountText.innerText = views;

      viewCountText.classList.add('fadeIn');
    }, 5000);
  }
  /* End - Product View Count */

  /* Start - Product Custom Quantity Selector */
  const customQuantitySelector = document.querySelector('.product__custom-quantity-selector');
  if (customQuantitySelector != null) {
    const customQuantityBoxes = customQuantitySelector.querySelectorAll('.product__custom-quantity-selector--box');
    const customQuantitySelected = customQuantitySelector.querySelector('.product__custom-quantity-selector--selected span');

    if (customQuantitySelector.dataset.product == 'pelsbarn-cooling-mat-bundles') {
      const coolingMatBundles = document.querySelector('input[data-product-handle="pelsbarn-cooling-mat-bundles"]');
      let coolingMatBundlesOriginalValue = coolingMatBundles.value;
      if (coolingMatBundlesOriginalValue.indexOf(' - ') != -1) {
        const coolingMatBundlesOriginalValueSplit = coolingMatBundlesOriginalValue.split(' - ');
        coolingMatBundlesOriginalValue = coolingMatBundlesOriginalValueSplit[1];
      }
      const giftsMainBlocks = document.querySelectorAll(".gifts-main-block");
      
      customQuantityBoxes.forEach((customQuantityBox) => {
        const customQuantityBoxCheckbox = customQuantityBox.querySelector('input');
        const customQuantityBoxTitle = customQuantityBox.querySelector('.product__custom-quantity-selector--info__title').innerText;
        const customQuantityBoxPrice = customQuantityBox.querySelector('.product__custom-quantity-selector--regular-price').innerText;
        
        customQuantityBoxCheckbox.addEventListener('change', () => {
          customQuantitySelected.innerText = customQuantityBoxTitle;

          if (coolingMatBundles != null) {
            let quantity = '1';
            if (customQuantityBoxCheckbox.getAttribute('id').indexOf('_2') != -1) {
              quantity = '2';
            } else if (customQuantityBoxCheckbox.getAttribute('id').indexOf('_3') != -1) {
              quantity = '3';
            }
            coolingMatBundles.value = "x" + quantity + " - " + coolingMatBundlesOriginalValue;
          }
          
          if (giftsMainBlocks.length > 0) {
            giftsMainBlocks.forEach((giftsMainBlock) => {
              const giftValues = giftsMainBlock.querySelectorAll(".gifts-image-container strong");
              
              if (giftValues.length > 0) {
                giftValues.forEach((giftValue) => {
                  giftValue.innerText = customQuantityBoxPrice;
                });
              }
            });
          }
        });
      });
    } else if (customQuantitySelector.dataset.product == 'lifeshield-supplement') {
      const newPDPButtonPrice = document.querySelector('.button--add-to-cart--with-price');

      customQuantityBoxes.forEach((customQuantityBox) => {
        const customQuantityBoxCheckbox = customQuantityBox.querySelector('input');
        const customQuantityBoxPrice = customQuantityBox.querySelector('.product__custom-quantity-selector--regular-price');
        const customQuantityBoxSalePrice = customQuantityBox.querySelector('.product__custom-quantity-selector--sale-price');
        const customQuantityBoxSave = customQuantityBox.querySelector('.product__custom-quantity-selector--info__title--save-badge');
        const customQuantityBoxTotalValue = customQuantitySelector.querySelector('.product__custom-quantity-selector--box__total-value span');
        const customQuantityBoxTotalPay = customQuantitySelector.querySelector('.product__custom-quantity-selector--box__total-pay span');
        const customQuantityBoxTotalSave = customQuantitySelector.querySelector('.product__custom-quantity-selector--box__total-save span');

        customQuantityBoxCheckbox.addEventListener('change', () => {
          if (customQuantityBoxSave != null) {
            customQuantityBoxTotalValue.textContent = customQuantityBoxSalePrice.textContent;
            customQuantityBoxTotalPay.textContent = customQuantityBoxPrice.textContent;
            customQuantityBoxTotalSave.textContent = customQuantityBoxSave.textContent;
          }

          newPDPButtonPrice.textContent = `Add to cart • ${customQuantityBoxPrice.textContent}`;
        });
      });
    } else {
      customQuantityBoxes.forEach((customQuantityBox) => {
        const customQuantityBoxCheckbox = customQuantityBox.querySelector('input');
        const customQuantityBoxPrice = customQuantityBox.querySelector('.product__custom-quantity-selector--regular-price');
        const customQuantityBoxSalePrice = customQuantityBox.querySelector('.product__custom-quantity-selector--sale-price');
        const customQuantityBoxSave = customQuantityBox.querySelector('.product__custom-quantity-selector--info__title--save-badge');
        const customQuantityBoxTotalValue = customQuantitySelector.querySelector('.product__custom-quantity-selector--box__total-value span');
        const customQuantityBoxTotalPay = customQuantitySelector.querySelector('.product__custom-quantity-selector--box__total-pay span');
        const customQuantityBoxTotalSave = customQuantitySelector.querySelector('.product__custom-quantity-selector--box__total-save span');
        
        customQuantityBoxCheckbox.addEventListener('change', () => {
          if (customQuantityBoxSave != null) {
            customQuantityBoxTotalValue.textContent = customQuantityBoxSalePrice.textContent;
            customQuantityBoxTotalPay.textContent = customQuantityBoxPrice.textContent;
            customQuantityBoxTotalSave.textContent = customQuantityBoxSave.textContent;
          }
        });
      });
    }
  }
  /* End - Product Custom Quantity Selector */

  /* Start - Product Page Videos */
  const videosSliderMedias = document.querySelectorAll('.product__videos--medias__slider--media');

  if (videosSliderMedias.length > 0) {
    videosSliderMedias.forEach((videosSliderMedia) => {
      const videoMedia = videosSliderMedia.querySelector('video');
      const videoMediaImage = videosSliderMedia.querySelector('.product__videos--medias__slider--media__image');

      videoMediaImage.addEventListener('click', (e) => {
        videoMedia.addEventListener('play', () => {
          videosSliderMedias.forEach(other => {
            const otherMedia = other.querySelector('video');
            if (otherMedia !== videoMedia && !otherMedia.paused) {
              otherMedia.pause();
            }
          });
        });

        videoMediaImage.remove();
        videoMedia.play();
      });
    });
  }
  /* End - Product Page Videos */

  /* Start - Product Vet Recommendation */
  const vetRecommendationLinks = document.querySelectorAll(
    ".product__vet-recommendation a"
  );
  
  if (vetRecommendationLinks.length > 0) {
    vetRecommendationLinks.forEach((vetRecommendationLink) => {
      const vetRecommendationModal = document.querySelector(
        "#VetRecommendationModal"
      );
      const vetRecommendationModalClose = document.querySelector(
        ".vet-recommendation-modal--content-close"
      );
      const body = document.querySelector("body");

      vetRecommendationModal.addEventListener('click', (e) => {
        const target = e.target;

        if (target.classList == 'vet-recommendation-modal') {
          body.classList.remove("overflow-hidden");
          vetRecommendationModal.classList.add("hidden");
        }
      });

      vetRecommendationLink.addEventListener("click", (e) => {
        e.preventDefault();

        body.classList.add("overflow-hidden");
        vetRecommendationModal.classList.remove("hidden");
      });

      vetRecommendationModalClose.addEventListener("click", (e) => {
        e.preventDefault();

        body.classList.remove("overflow-hidden");
        vetRecommendationModal.classList.add("hidden");
      });
    });
  }
  /* End - Product Vet Recommendation */
});

function isDesignMode() {
  return window.Shopify && window.Shopify.designMode;
}

function logPopup(data) {
  const w = window.open('', '_blank', 'width=400,height=300');
  w.document.write('<pre>' + JSON.stringify(data, null, 2) + '</pre>');
  w.document.close();
}
/* End - Custom Code */

$(document).ready(function () {
  var randomImage = [];

  $(".image_gallery_cover .image_gallery img").each(function () {
    var get_gallery_src = $(this).attr("src");
    randomImage.push(get_gallery_src);
  });

  setInterval(function () {
    randomImage.sort(function () {
      return 0.5 - Math.random();
    });
    $(".image_gallery_cover .image_gallery img").each(function (i) {
      $(this).attr("src", randomImage[i % randomImage.length]);
    });
  }, 3000);
});

$(".tabify_title").click(function (e) {
  e.preventDefault();
  var tabify = $(this).attr("id");
  $(".tabify_title").removeClass("active_tabify");
  $(this).addClass("active_tabify");
  $(".tabify_title")
    .closest(".product_center_section")
    .find(".tabcontent")
    .removeClass("active_tabify_video");
  $(this)
    .closest(".product_center_section")
    .find(".tabcontent#" + tabify)
    .addClass("active_tabify_video");
});

$(document).ready(function () {
  if ($(".gryffeditor").length < 1) {
    // $('.tab_slider_block_cover').slick({
    //     dots: false,
    //     infinite: false,
    //     slidesToShow: 3,
    //     arrows: true,
    //     prevArrow: '<button class="slide-arrow prev-arrow"><svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" role="presentation" class="icon slider_icon icon-chevron" fill="none" viewBox="0 0 32 32"><path fill-rule="evenodd" clip-rule="evenodd" d="M12.943 24.943l8-8c0.521-0.521 0.521-1.365 0-1.885l-8-8c-0.521-0.521-1.365-0.521-1.885 0s-0.521 1.365 0 1.885l7.057 7.057-7.057 7.057c-0.521 0.521-0.521 1.365 0 1.885s1.365 0.521 1.885 0z" fill="currentColor"></path></svg></button>',
    //     nextArrow: '<button class="slide-arrow next-arrow"><svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" role="presentation" class="icon slider_icon icon-chevron" fill="none" viewBox="0 0 32 32"><path fill-rule="evenodd" clip-rule="evenodd" d="M12.943 24.943l8-8c0.521-0.521 0.521-1.365 0-1.885l-8-8c-0.521-0.521-1.365-0.521-1.885 0s-0.521 1.365 0 1.885l7.057 7.057-7.057 7.057c-0.521 0.521-0.521 1.365 0 1.885s1.365 0.521 1.885 0z" fill="currentColor"></path></svg></button>',
    //     responsive: [
    //         {
    //             breakpoint: 750,
    //             settings: {
    //                 slidesToShow: 2
    //             }
    //         },
    //         {
    //             breakpoint: 500,
    //             settings: {
    //                 slidesToShow: 1
    //             }
    //         }
    //     ]
    // });

    $(".tab_main_title ").click(function (e) {
      e.preventDefault();
      var tabify_slider = $(this).attr("id");
      $(".tab_main_title ").removeClass("is-active");
      $(this).addClass("is-active");
      $(".tab_main_title")
        .closest(".tabify_slider_cover_main")
        .find(".tab_slider_cover_all")
        .removeClass("is-active_slider");
      $(this)
        .closest(".tabify_slider_cover_main")
        .find(".tab_slider_cover_all#" + tabify_slider)
        .addClass("is-active_slider");

      if ($(".tab_slider_block_cover").hasClass("slick-initialized")) {
        $(".tab_slider_block_cover").slick("unslick");
      }

      if (!$(".tab_slider_block_cover").hasClass("slick-initialized")) {
        $(".tab_slider_block_cover").slick({
          dots: false,
          infinite: false,
          slidesToShow: 3,
          arrows: true,
          prevArrow:
            '<button class="slide-arrow prev-arrow"><svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" role="presentation" class="icon slider_icon icon-chevron" fill="none" viewBox="0 0 32 32"><path fill-rule="evenodd" clip-rule="evenodd" d="M12.943 24.943l8-8c0.521-0.521 0.521-1.365 0-1.885l-8-8c-0.521-0.521-1.365-0.521-1.885 0s-0.521 1.365 0 1.885l7.057 7.057-7.057 7.057c-0.521 0.521-0.521 1.365 0 1.885s1.365 0.521 1.885 0z" fill="currentColor"></path></svg></button>',
          nextArrow:
            '<button class="slide-arrow next-arrow"><svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" role="presentation" class="icon slider_icon icon-chevron" fill="none" viewBox="0 0 32 32"><path fill-rule="evenodd" clip-rule="evenodd" d="M12.943 24.943l8-8c0.521-0.521 0.521-1.365 0-1.885l-8-8c-0.521-0.521-1.365-0.521-1.885 0s-0.521 1.365 0 1.885l7.057 7.057-7.057 7.057c-0.521 0.521-0.521 1.365 0 1.885s1.365 0.521 1.885 0z" fill="currentColor"></path></svg></button>',
          responsive: [
            {
              breakpoint: 750,
              settings: {
                slidesToShow: 2,
                arrows: true,
              },
            },
            {
              breakpoint: 500,
              settings: {
                slidesToShow: 1,
                arrows: true,
              },
            },
          ],
        });
      }
    });
  }
});

$(".expanded-blocks__title").click(function () {
  var accordion = $(this)
    .parents(".expandable-blocks__wrapper")
    .hasClass("active");

  if (accordion) {
    $(this).parents(".expandable-blocks__wrapper").removeClass("active");
  } else {
    $(".expanded-blocks__title")
      .parents(".expandable-blocks__wrapper")
      .removeClass("active");
    $(this).parents(".expandable-blocks__wrapper").addClass("active");
  }
});

$(".images-with-description__item").click(function () {
  var tabify_new = $(this).data("tab_new");
  var tab_active = $(this).hasClass("active");
  if (tab_active) {
    $(this).removeClass("active");
    $(".images-with-description_content").removeClass("active");
  } else {
    $(".images-with-description__item").removeClass("active");
    $(this).addClashowLoadingOverlayss("active");
    $(".images-with-description_content").removeClass("active");
    $(
      ".three_column_tab_cover .images-with-description_content." + tabify_new
    ).addClass("active");
  }
});

$(".images-with-description_content .close_icon").click(function () {
  $(this).parents(".images-with-description_content").removeClass("active");
  $(".images-with-description__item").removeClass("active");
});

$(window).scroll(function () {
  if ($("body").hasClass("product_template")) {
    var scrollTop = $(window).scrollTop();
    if (scrollTop > 50) {
      $(".last_chance_bar").css("display", "flex");
    } else {
      $(".last_chance_bar").css("display", "none");
    }
  }
});

$(document).ready(function () {
  var countDownDateToday = new Date();
  countDownDateToday.setDate(countDownDateToday.getDate() + 1);
  countDownDateToday.setHours(0, 0, 0, 0);
  var countDownDate = countDownDateToday.getTime();

  var x = setInterval(function () {
    var now = new Date().getTime();
    var distance = countDownDate - now;

    var hours = (
      "0" + Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
    ).slice(-2);
    var minutes = (
      "0" + Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60))
    ).slice(-2);
    var seconds = ("0" + Math.floor((distance % (1000 * 60)) / 1000)).slice(-2);
    $(".last_chance_bar__inner__hours").html(hours);
    $(".last_chance_bar__inner__mins").html(minutes);
    $(".last_chance_bar__inner__secs").html(seconds);

    if (distance < 0) {
      clearInterval(x);
    }
  }, 1000);
});

$(".opp_all_product_cover").flickity({
  draggable: true,
  pageDots: true,
  cellAlign: "left",
  adaptiveHeight: true,
});
var $galleryCells = $(".opp_all_product_cover .offer_purchase_product_cover");

if ($galleryCells.length < 2) {
  $(".opp_all_product_cover .flickity-page-dots").addClass("is-hiding-nav-ui");
}

$(".tabify_main_title ").click(function (e) {
  e.preventDefault();
  var tabify = $(this).attr("id");
  $(".tabify_main_title").removeClass("active_tabify");
  $(this).addClass("active_tabify");
  $(".content_tab").removeClass("active_tabify_content");
  $(".content_tab#" + tabify).addClass("active_tabify_content");
});

document.addEventListener("DOMContentLoaded", function () {
  const submitButton = document.querySelector(
    ".product-block__extra-product .extra-product_submit"
  );

  if (!submitButton) return;
  var this_cart =
    document.querySelector("cart-notification") ||
    document.querySelector("cart-drawer");

  submitButton.addEventListener("click", function () {
    const checkboxes = document.querySelectorAll(
      '.product-block__extra-product input[name="extra_product_variant"]:checked'
    );
    if (checkboxes.length === 0) {
      alert("Please select at least one variant.");
      return;
    }

    const items = Array.from(checkboxes).map((input) => ({
      id: input.value,
      quantity: 1,
    }));

    const formData = new FormData();
    items.forEach((item, index) => {
      formData.append(`items[${index}][id]`, item.id);
      formData.append(`items[${index}][quantity]`, item.quantity);
    });

    if (this_cart) {
      formData.append(
        "sections",
        this_cart.getSectionsToRender().map((section) => section.id)
      );
      formData.append("sections_url", window.location.pathname);
      this_cart.setActiveElement(document.activeElement);
    }

    const config = fetchConfig("javascript");
    config.headers["X-Requested-With"] = "XMLHttpRequest";
    delete config.headers["Content-Type"]; // Important for FormData
    config.body = formData;

    fetch(`${routes.cart_add_url}`, config)
      .then((response) => {
        return response.json();
      })
      .then((response) => {
        if (!this_cart) {
          window.location = window.routes.cart_url;
          return;
        }
        this_cart.renderContents(response);
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        if (this_cart && this_cart.classList.contains("is-empty"))
          this_cart.classList.remove("is-empty");
      });
  });
});
